module.exports = __webpack_public_path__ + "loading.gif"


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-widgets/dist/img/loading.gif
 ** module id = 233
 ** module chunks = 2
 **/